var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"js-paymentez-checkout",on:{"click":_vm.openPaymentezModal}},[_c('img',{attrs:{"src":"https://developers.paymentez.com/wp-content/uploads/2017/10/logo.png","alt":"logo de paymentez"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08216138","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/paymentsMethods/paymentez.vue
// module id = 1251
// module chunks = 39